module.exports = __webpack_public_path__ + "img/jieshao_tsxl.8f9288b6.png";